<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card
            flat>
            <v-tabs
              v-model="selected.menu"
              background-color="transparent"
              color="#ff64ad"
              slider-size="5"
              show-arrows
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              dense
              grow
              class="d-flex justify-start tabs-stream">
              <v-tab
                v-for="(item, index) in menu"
                :key="index"
                class="px-0 mr-4 d-flex align-center">
                <v-avatar
                  tile
                  size="20">
                  <v-img 
                    contain
                    :src="item.icon">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          size="20"
                          color="#ff64ad">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span 
                  class="body-2 text-capitalize ml-2" 
                  :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                  {{ item.title }}
                </span>
              </v-tab>
            </v-tabs>

            <div>
              <Layanan v-if="selected.menu === 0"
                :detail="menu[selected.menu]" />

              <Datadukung v-if="selected.menu === 1"
                :detail="menu[selected.menu]" />

              <Ketentuan v-if="selected.menu === 2"
                :detail="menu[selected.menu]" />

              <BPP v-if="selected.menu === 3"
                :detail="menu[selected.menu]" />
            </div>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },
        menu: [
          {
            title: 'Layanan',
            icon: require('@/assets/image/online_service.png')
          },
          {
            title: 'Data Dukung',
            icon: require('@/assets/image/doc_5.png')
          },
          {
            title: 'Ketentuan',
            icon: require('@/assets/image/privacy_policy.png')
          },
          // tambahan bpp
          {
            title: 'BPP',
            icon: require('@/assets/image/bpp.png')
          }
        ]
      }
    },
    components: {
      Layanan: () => import(/* webpackPrefetch: true */ '@/components/service/layanan.vue'),
      Datadukung: () => import(/* webpackPrefetch: true */ '@/components/service/data_dukung.vue'),
      Ketentuan: () => import(/* webpackPrefetch: true */ '@/components/service/ketentuan.vue'),
      BPP: () => import(/* webpackPrefetch: true */ '@/components/service/bpp.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      this.selected.menu = this.$route.query.menu !== undefined ? 3 : 0
    },
    methods: {
      
    }
  }
</script>